import { fromJS, List, Map } from 'immutable'
import { GET_CUSTOMER_CURRENCY } from '../actions/actionTypes'

const initialState = Map()

interface CustomerCurrencyDataAction {
  type: typeof GET_CUSTOMER_CURRENCY.REQUEST | typeof GET_CUSTOMER_CURRENCY.SUCCESS
  body?: List<string>
  params: {
    customerNumber: string
    departmentName: string
  }
}

export default function reducer(state = initialState, action: CustomerCurrencyDataAction) {
  switch (action.type) {
    case GET_CUSTOMER_CURRENCY.REQUEST: {
      const { customerNumber, departmentName } = action.params
      if (!customerNumber || !departmentName) {
        return state
      }
      return state.deleteIn(['data', customerNumber, departmentName])
    }
    case GET_CUSTOMER_CURRENCY.SUCCESS: {
      const { customerNumber, departmentName } = action.params
      if (!customerNumber || !departmentName || !action.body) {
        return state
      }
      return state.setIn(['data', customerNumber, departmentName], fromJS(action.body).toArray())
    }
    default:
      return state
  }
}
